import { render, staticRenderFns } from "./Regiao.vue?vue&type=template&id=47b684ae"
import script from "./Regiao.vue?vue&type=script&lang=js"
export * from "./Regiao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports